<div class="container container-main">
  <app-reports-general-header />
  <div class="card border-0 p-3">
    <app-reporting-subnav></app-reporting-subnav>
    <div class="card-body p-0 p-xl-3">
      <div class="p-xl-3">
        <app-report-filter-bar
          [reportName]="'proforms_reports'"
          [isAnonymous]="
            selectedProForm?.anonymity === ProFormAnonymity.REQUIRED
          "
          [canFilterByDistrict]="canFilterByDistrict"></app-report-filter-bar>
      </div>
      <div class="row justify-content-center mt-3">
        <h2 class="text-center fw-800 mt-3" style="font-size: 20px">
          Select a ProForm to see data:
        </h2>

        <div class="row d-flex justify-content-center">
          <div class="col-md-3 mb-2">
            <ng-select
              [labelForId]="proformTypes"
              [items]="proformTypes"
              bindLabel="value"
              [clearable]="false"
              [searchable]="false"
              bindValue="key"
              [ngModel]="selectedType"
              (ngModelChange)="onTypeChange($event)"
              name="type"
              placeholder="Select Type" />
          </div>
          <div class="col-md-5 mb-2">
            @if(!loading && proFormsList) {
            <ng-select
              *ngIf="proFormsList.length > 0; else noForms"
              [labelForId]="'formselect'"
              [items]="proFormsList"
              bindLabel="title"
              [disabled]="loading"
              placeholder="Select a form to see data"
              [(ngModel)]="selectedProForm"
              (change)="updateProFormSelect($event)" />
            }
          </div>
        </div>
        <ng-template #noForms>
          <div
            class="pb-5 d-flex justify-content-center align-items-center"
            style="min-height: 200px">
            No forms are available for
            {{ districtDisplayName || user.district?.title || "" }}
          </div>
        </ng-template>
      </div>

      <div *ngIf="selectedProForm">
        <div id="calibration-chart" class="p-5 mx-3" *ngIf="formHasCalibration">
          <div class="position-relative">
            <h3 class="fs-21 fw-800 text-center mb-4">Calibration Averages</h3>
            <app-calibration-table
              [requestParams]="calibrationRequestParams"
              [isObsvCalibration]="false" />
          </div>
        </div>

        <div class="row mt-5">
          <div
            class="col-10 offset-1 d-flex align-itmes-center justify-content-center">
            <h3 class="fs-26 fw-800 text-center d-flex align-items-center mb-0">
              Form Responses
            </h3>
          </div>
          <div class="col-1 d-flex justify-content-end align-itmes-center">
            <button
              ngbTooltip="Download CSV"
              aria-label="Download CSV"
              class="btn download-button"
              container="body"
              placement="bottom"
              [autoClose]="false"
              [disabled]="disableDownload"
              (click)="downloadCSV()"
              [ngbPopover]="csvDownloadingPopover"
              #p="ngbPopover">
              <i [ngClass]="['bi', 'fs-21', 'bi-download']"></i>
            </button>
            <ng-template #csvDownloadingPopover>
              <div class="p-2">
                An email will be sent to you with a link to download the CSV.
              </div>
              <div class="p-2 d-flex justify-content-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="disableDownload = false; p.close()">
                  OK
                </button>
              </div>
            </ng-template>
          </div>
        </div>

        <ng-container
          *ngIf="
            this.selectedProForm.type === 'observation' ||
            this.selectedProForm.type === 'calibration'
          ">
          <div *ngIf="totalSubmissions && totalSubmissions > 0" class="row">
            <div
              class="col-12 p-0 p-mb-5 mt-2 fw-400 fs-15 text-center fst-italic">
              Report reflects data from
              {{ totalSubmissions }} form<span
                *ngIf="totalSubmissions && totalSubmissions > 1"
                >s</span
              >.
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="!loading; else loader">
        <div class="row justify-content-center mt-3"></div>
      </ng-container>
      <ng-template #loader>
        <div class="w-100" style="height: 500px">
          <app-loader></app-loader>
        </div>
      </ng-template>

      <div class="w-100" style="min-height: 300px">
        <div *ngIf="selectedProForm">
          @if(this.selectedProForm.type === 'quiz' && this.quizSummaryParams) {
          <app-proforms-quiz-summary [requestParams]="this.quizSummaryParams" />
          }

          <div *ngFor="let order of questionsOrder; let i = index">
            <ng-container
              *ngFor="
                let requestParams of observedAnswersParams;
                let i = index
              ">
              @if(getQuestionId(requestParams) === order){
              <div
                id="observed-{{ stripHtml(questionTitles[i]) }}"
                class="p-0 p-md-5 mx-xl-3">
                <div class="position-relative my-4">
                  <h3 class="fs-21 fw-800 text-center">
                    <app-safehtml html="{{ questionTitles[i] }}"></app-safehtml>
                  </h3>
                  <div class="fs-11 fw-800 color-gray mb-3 text-center">
                    {{ optionTypes[i] | uppercase }}
                  </div>
                  @if(optionTypes[i] === 'radio' || optionTypes[i] ===
                  'dropdown') {
                  <app-report-controller
                    chartId="proform-{{ stripHtml(questionTitles[i]) }}"
                    [drilldownDimensions]="['school_name', 'user_name']"
                    [initialDrilldownFilter]="
                      'proform_question_answer_option_name'
                    "
                    [chartType]="[chartTypes.Donut]"
                    [colorPalette]="chartColors"
                    [tooltipTrigger]="'item'"
                    [limitDataPresentation]="50"
                    (apiResponseEvent)="getApiResponseEvent($event)"
                    [requestParams]="requestParams" />
                  } @else if (optionTypes[i] === 'rubric') {
                  <app-report-controller
                    chartId="proform-{{ stripHtml(questionTitles[i]) }}"
                    cardHeight="18rem"
                    [drilldownDimensions]="['school_name', 'user_name']"
                    [initialDrilldownFilter]="'standard_num'"
                    [requestParams]="requestParams"
                    [chartType]="[chartTypes.HorizontalStackedBar]"
                    [colorPalette]="chartColors"
                    [replaceChartOptions]="true"
                    [wrapAxisLabels]="300"
                    (apiResponseEvent)="getApiResponseEvent($event)"
                    [legendOptions]="{
                      show: true,
                      bottom: 0,
                      icon: 'circle',
                      formatter: '{name}',
                      textStyle: {
                        fontFamily: 'greycliff-cf'
                      }
                    }"
                    [gridDimensions]="{
                    top: '30px',
                    left: '23px',
                    right: '15px',
                    bottom: '40px',
                     }" />
                  } @else if (optionTypes[i] === 'checkboxgrid') {
                  <app-report-controller
                    chartId="proform-{{ stripHtml(questionTitles[i]) }}"
                    cardHeight="18rem"
                    [drilldownDimensions]="['school_name', 'user_name']"
                    [initialDrilldownFilter]="'row_name'"
                    [isSqlRequest]="true"
                    [sqlRequestParams]="{
                      report: 'proformCheckboxGrid',
                      dimension: 'row_name',
                      filters: requestParams.filters
                    }"
                    [chartType]="[chartTypes.HorizontalStackedBar]"
                    [colorPalette]="chartColors"
                    [replaceChartOptions]="true"
                    (apiResponseEvent)="getApiResponseEvent($event)"
                    [legendOptions]="{
                      show: true,
                      bottom: 0,
                      icon: 'circle',
                      formatter: '{name}',
                      textStyle: {
                        fontFamily: 'greycliff-cf'
                      }
                    }"
                    [gridDimensions]="{
                    top: '30px',
                    left: '23px',
                    right: '15px',
                    bottom: '40px',
                     }" />
                  } @else if (optionTypes[i] === 'checkbox') {
                  <app-report-controller
                    chartId="observed-{{ questionTitles[i] }}"
                    cardHeight="18rem"
                    [drilldownDimensions]="['school_name', 'user_name']"
                    [initialDrilldownFilter]="
                      'proform_question_answer_option_name'
                    "
                    [chartColor]="['#d95195']"
                    [chartType]="[chartTypes.HorizontalBar]"
                    (apiResponseEvent)="getApiResponseEvent($event)"
                    [gridDimensions]="{
                      top: '30px',
                      left: '23px',
                      right: '15px',
                      bottom: '35px',
                    }"
                    [requestParams]="requestParams" />
                  } @else {
                  <app-report-controller
                    chartId="proform-{{ stripHtml(questionTitles[i]) }}"
                    cardHeight="18rem"
                    [chartType]="[chartTypes.HorizontalBar]"
                    [chartColor]="['#d95195']"
                    [tooltipTrigger]="'item'"
                    [horizontalBarThreshold]="5"
                    (apiResponseEvent)="getApiResponseEvent($event)"
                    [gridDimensions]="{
                      top: '30px',
                      left: '23px',
                      right: '15px',
                      bottom: '35px',
                    }"
                    [requestParams]="requestParams" />
                  }
                </div>
              </div>
              }
            </ng-container>

            <ng-container
              *ngFor="let requestParams of textAnswersParams; let i = index">
              @if(getQuestionId(requestParams) === order){
              @if(textQuestionTypes[i] !== 'contentblock') {
              <div
                id="observed-{{ stripHtml(textQuestionTitles[i]) }}"
                class="p-0 p-md-5 mx-3">
                <h3 class="fs-21 fw-800 text-center">
                  <app-safehtml
                    html="{{ textQuestionTitles[i] }}"></app-safehtml>
                </h3>
                <div class="fs-11 fw-800 color-gray text-center mb-3">
                  {{ textQuestionTypes[i] | uppercase }}
                </div>
                @if(textQuestionTypes[i] === 'text' || textQuestionTypes[i] ===
                'textarea') {
                <app-proforms-text-response
                  [requestParams]="requestParams"
                  [fieldId]="textQuestionIds[i]"
                  [questionTitle]="textQuestionTitles[i]" />
                } @if(textQuestionTypes[i] === 'attachment') {
                <app-proforms-attachment-response
                  [requestParams]="requestParams"
                  [fieldId]="textQuestionIds[i]"
                  [questionTitle]="textQuestionTitles[i]" />
                }
              </div>
              } @else {
              <div
                id="observed-{{ stripHtml(textQuestionTitles[i]) }}"
                class="p-0 p-md-5 mx-3">
                <app-safehtml html="{{ textQuestionTitles[i] }}"></app-safehtml>
                <div class="fs-11 fw-800 color-gray text-center mb-3">
                  {{ textQuestionTypes[i] | uppercase }}
                </div>
              </div>
              } }
            </ng-container>
          </div>

          @if(formSubmissionsParams) {
          <h3 class="fs-21 fw-800 text-center mt-3 mb-4">Submissions</h3>

          <app-proforms-submissions
            [selectedType]="selectedType"
            [formId]="this.selectedProForm.id"
            [requestParams]="this.formSubmissionsParams"
            (numSubmissionsChange)="updateSubmissionsCount($event)" />
          }
        </div>
      </div>
      <div class="mt-5 text-muted small text-end">
        Data last refreshed at {{ lastUpdatedDate }}
      </div>
    </div>
  </div>
</div>
